// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"360":"77583442","407":"df6f89f7","637":"d02dfa7e","835":"fd754338"}[chunkId] + ".chunk.js";
};